// extracted by mini-css-extract-plugin
export default {"root":"_3g0FlQwz","inList":"GikJvPqF"};